function imageFieldToSectionId(fieldKey) {
  const map = {
    card_logo_image_wide: "card-type-field-wide",
    card_logo_image_square: "card-type-field-square",
    card_strip_image: "card-type-field-strip",
    card_hero_image: "card-type-field-hero",
  }
  return map[fieldKey] || null
}

function findControlForField(form, fieldKey) {
  const imageSectionId = imageFieldToSectionId(fieldKey)
  if (imageSectionId) {
    const el = document.getElementById(imageSectionId)
    if (el) return el
  }
  const coloursId = "card-type-form-colours"
  if (["background_colour", "foreground_colour", "label_colour"].includes(fieldKey)) {
    const el = document.getElementById(coloursId)
    if (el) return el
  }
  const byName = form.querySelector(`[name="card_type[${fieldKey}]"]`)
  if (byName) return byName
  const byFile = form.querySelector(`[name="card_type[${fieldKey}_file]"]`)
  if (byFile) return byFile
  return null
}

function highlightTargetFor(form, control) {
  const row = control.closest(".row")
  if (row && form.contains(row)) return row
  const formGroup = control.closest(".form-group")
  if (formGroup && form.contains(formGroup)) return formGroup
  if (control.classList.contains("card") && control.querySelector(".card-body")) {
    return control.querySelector(".card-body")
  }
  return control
}

function scrollToField(form, fieldKey) {
  const control = findControlForField(form, fieldKey)
  if (!control) return
  const scrollTarget = control.closest(".row") || control.closest(".form-group") || control
  scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" })
}

function clearHighlight() {
  document.querySelectorAll(".card-type-preview-highlight").forEach((el) => {
    el.classList.remove("card-type-preview-highlight")
  })
}

export function setupPreviewLayout(scopeElement) {
  const previewRow = scopeElement.closest(".row")
  if (!previewRow) return

  const container = previewRow.parentElement
  if (container.querySelector(".card-type-form-with-preview__fields")) return

  container.classList.add("card-type-form-with-preview")
  const rows = Array.from(container.children).filter((el) => el.classList.contains("row"))
  const fieldsCol = document.createElement("div")
  fieldsCol.className = "card-type-form-with-preview__fields"
  rows.forEach((row) => {
    if (row !== previewRow) fieldsCol.appendChild(row)
  })
  previewRow.after(fieldsCol)
}

export function setupZoneClicks(scopeElement, form) {
  let highlightTimeout = null
  const zones = scopeElement.querySelectorAll(".card-preview__zone[data-card-field]")

  const onZoneClick = (event, zone) => {
    const field = zone.getAttribute("data-card-field")
    if (!field) return
    event.stopPropagation()
    scrollToField(form, field)
    const control = findControlForField(form, field)
    if (!control) return
    clearHighlight()
    const target = highlightTargetFor(form, control)
    if (target) {
      target.classList.add("card-type-preview-highlight")
      highlightTimeout = setTimeout(clearHighlight, 2000)
    }
  }

  const listeners = []
  zones.forEach((zone) => {
    const fn = (e) => onZoneClick(e, zone)
    zone.addEventListener("click", fn)
    listeners.push([zone, fn])
  })

  return () => {
    if (highlightTimeout) clearTimeout(highlightTimeout)
    listeners.forEach(([zone, fn]) => zone.removeEventListener("click", fn))
    clearHighlight()
  }
}
